import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default class FeedbackController extends React.Component {
    constructor(props) {
        super(props);

        this.timeout = null;
        this.state = { hidden: false };
    }

    componentWillUpdate() {
        if (this.state.hidden) {
            this.setState({ hidden: false });
        }
    }

    componentDidUpdate() {
        if (!this.state.hidden && this.props.autoHide) {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.setState({ hidden: true });
            }, this.props.messageTimeout);
        }
    }

    render() {
        if (typeof this.props.message === "undefined" || this.state.hidden) {
            return null;
        }

        const FeedbackView = ComponentRegistry.get(this.props.view);

        return (<FeedbackView {...this.props} onClose={() => this.setState({ hidden: true })} />);
    }
}

FeedbackController.propTypes = {
    view: PropTypes.string.isRequired,
    autoHide: PropTypes.bool,
    messageTimeout: PropTypes.number,
    message: PropTypes.string,
};

FeedbackController.defaultProps = {
    view: "BasketViewsFeedbackView",
    autoHide: false,
    messageTimeout: 1000,
};




// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Controllers/FeedbackController.jsx